export default "__VITE_ASSET__DjDx2beM__"